import React from 'react';

import {
  Alert,
} from 'react-bootstrap';

export default ({ text }) => (
  <Alert variant="danger">{text}</Alert>
);
